import { render } from "./PR18-11202022.vue?vue&type=template&id=552520ea"
import script from "./PR18-11202022.vue?vue&type=script&lang=js"
export * from "./PR18-11202022.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__